import { useState, Fragment } from 'react';
// @mui
import {
  Box,
  Typography,
  TextField,
  Stack,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { StaticDateRangePicker } from '@mui/x-date-pickers-pro';
// hooks
import useResponsive from '../../hooks/useResponsive';
// components
import { fKrDateKST } from '../../utils/formatTime';

export default function ContractDateRangeDialog({ minStartDate, initialValue, plan, isOpen, closeDialog }) {
  const [value, setValue] = useState([null, null]);
  const [trialValue, setTrialValue] = useState([null, null]);
  const [longtermValue, setLongtermValue] = useState([null, null]);
  const smUp = useResponsive('up', 'sm');
  const minStart = new Date(minStartDate);
  const startableDate = new Date(minStart.getTime() + (minStart.getTimezoneOffset() > 0 ? minStart.getTimezoneOffset() * 60000 : 0));
  const trialSelected = plan === 'trial';
  const longtermSelected = plan === 'longterm';

  const setContractRange = async () => {
    closeDialog(value, trialValue, longtermValue);
  }

  const justCloseDialog = async () => {
    closeDialog();
    setValue(initialValue, initialValue);
  }

  const setRange = async (newValue) => {
    const [prevStart, prevEnd] = value;
    const [start, end] = newValue;

    let contractStartDate;
    if (start < prevStart) {
      contractStartDate = start;
    } else if (prevEnd < end) {
      contractStartDate = end;
    } else if (prevStart < start && start < prevEnd) {
      contractStartDate = start;
    } else if (prevStart < end && end < prevEnd) {
      contractStartDate = end;
    } else {
      contractStartDate = start;
    }

    const contractEndDate = new Date(contractStartDate);
    contractEndDate.setDate(contractEndDate.getDate() + 27);
    const trialContractEndDate = new Date(contractStartDate);
    trialContractEndDate.setDate(trialContractEndDate.getDate() + 13);
    const longtermContractEndDate = new Date(contractStartDate);
    longtermContractEndDate.setDate(longtermContractEndDate.getDate() + 55);
    setValue([contractStartDate, contractEndDate]);
    setTrialValue([contractStartDate, trialContractEndDate]);
    setLongtermValue([contractStartDate, longtermContractEndDate]);
  }

  return (
    <Dialog maxWidth="lg" open={isOpen} onClose={justCloseDialog}>
      <DialogTitle>
        계약 시작일을 선택해주세요
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: smUp ? 2 : 1 }}>
          크루는 {fKrDateKST(startableDate)} 부터 업무를 시작할 수 있습니다
        </DialogContentText>
        <StaticDateRangePicker
          displayStaticWrapperAs="desktop"
          closeOnSelect={false}
          calendars={smUp? 2 : 1}
          minDate={startableDate}
          value={longtermSelected ? longtermValue : trialSelected ? trialValue : value}
          justifyContent="center"
          onChange={(newValue) => {
            setRange(newValue);
          }}
          renderInput={(startProps, endProps) => (
            <Fragment>
              <TextField {...startProps} />
              <Box sx={{ mx: 2 }}> ~ </Box>
              <TextField {...endProps} />
            </Fragment>
          )}
        />
        {smUp && (
          <Fragment>
            <DialogContentText align="right" variant="caption" gutterBottom>
              {longtermSelected && '장기 '}{trialSelected && '체험판 '}계약 기간은 계약 시작일로부터 {longtermSelected ? '8주(56일)' : trialSelected ? '2주(14일)' : '4주(28일)'} 입니다.
            </DialogContentText>
            <Stack direction="row" alignItems="center" justifyContent="space-between">
              {(value && value[0] && value[1]) ? 
              (
                <Stack>
                  {trialSelected
                   ? <Typography><b>계약 기간</b>  {`${fKrDateKST(trialValue[0])} ~ ${fKrDateKST(trialValue[1])}`}</Typography>
                   : longtermSelected
                   ? <Typography><b>계약 기간</b>  {`${fKrDateKST(longtermValue[0])} ~ ${fKrDateKST(longtermValue[1])}`}</Typography>
                   : <Typography><b>계약 기간</b>  {`${fKrDateKST(value[0])} ~ ${fKrDateKST(value[1])}`}</Typography>
                  }
                </Stack>
              )
              :
              (<Typography><b>계약 기간</b> 시작일을 선택해주세요</Typography>)}
              <LoadingButton variant="contained" onClick={setContractRange}>
                계약 기간 설정 완료
              </LoadingButton>
            </Stack>
          </Fragment>
        )}

        {!smUp && (
          <Fragment>
            {(value && value[0] && value[1]) ? (
              <Stack>
                {trialSelected
                  ? <Typography variant="body2"><b>계약 기간</b>  {`${fKrDateKST(trialValue[0])} ~ ${fKrDateKST(trialValue[1])}`}</Typography>
                  : longtermSelected
                  ? <Typography variant="body2"><b>계약 기간</b>  {`${fKrDateKST(longtermValue[0])} ~ ${fKrDateKST(longtermValue[1])}`}</Typography>
                  : <Typography variant="body2"><b>계약 기간</b>  {`${fKrDateKST(value[0])} ~ ${fKrDateKST(value[1])}`}</Typography>
                }
              </Stack>
            ) : (
              <Typography>
                <b>계약 기간</b><br/>시작일을 선택해주세요
              </Typography>
            )}
            <DialogContentText variant="caption" paragraph>
            {longtermSelected && '장기 '}{trialSelected && '체험판 '}계약 기간은 {longtermSelected ? '8주(56일)' : trialSelected ? '2주(14일)' : '4주(28일)'} 입니다.
            </DialogContentText>
            <Stack direction="row" justifyContent="flex-end">
              <LoadingButton onClick={justCloseDialog}>
                취소
              </LoadingButton>
              <LoadingButton variant="contained" onClick={setContractRange}>
                계약 기간 설정 완료
              </LoadingButton>
            </Stack>
          </Fragment>
        )}
      </DialogContent>
    </Dialog>
  )
}